import React from 'react';
import { LoadingOverlay } from '../layout/LoadingOverlay';

var LoadingScreen = function LoadingScreen() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    className: "sr-only"
  }, "Loading..."), /*#__PURE__*/React.createElement(LoadingOverlay, null));
};

export { LoadingScreen };